import React from 'react';
import '../style/ProductCard.css';

const ProductCategoryCard = ({ categoryName, categoryDescription }) => {
  return (
    <div class="category-card div-separator-card">
      <p class="category-text">{categoryName}</p>
      <p class="category-description">{categoryDescription}</p>
    </div>
  );
};

export default ProductCategoryCard;